import React from 'react';

const columns = [
  { key: '2024', label: '2024' },
  { key: '2025', label: '2025' },
  { key: '2026', label: '2026' },
  { key: 'total', label: 'Total', isTotal: true },
] as const;

const rows = [
  {
    label: 'Sales',
    format: 'number' as const,
    values: {
      '2024': 108350,
      '2025': 327951,
      '2026': 129204,
      total: 565505,
    },
  },
  {
    label: 'Sales costs',
    format: 'number' as const,
    values: {
      '2024': 10500,
      '2025': 88132,
      '2026': 27665,
      total: 126298,
    },
  },
  {
    label: 'CAC',
    format: 'percentage' as const,
    values: {
      '2024': 9.69,
      '2025': 26.87,
      '2026': 21.41,
      total: 22.33,
    },
  },
] as const;

function formatNumber(value: number) {
  return new Intl.NumberFormat('es-AR', { maximumFractionDigits: 0 }).format(value);
}

function formatPercentage(value: number) {
  return `${new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)}%`;
}

function renderValue(value: number, format: 'number' | 'percentage') {
  return format === 'percentage' ? formatPercentage(value) : formatNumber(value);
}

export default function CacEvolutionSection() {
  return (
    <section className="card cac-evolution">
      <div className="cac-evolution__header">
        <div>
          <div className="cac-evolution__eyebrow">Static reference</div>
          <div className="cac-evolution__title">CAC evolution</div>
          <div className="muted cac-evolution__subtitle">Sales efficiency by year and cumulative total.</div>
        </div>
        <div className="cac-evolution__highlight" aria-label="Total CAC">
          <span>Total CAC</span>
          <strong>{formatPercentage(rows[2].values.total)}</strong>
        </div>
      </div>

      <div className="cac-evolution__table-wrap">
        <table className="cac-evolution__table">
          <thead>
            <tr>
              <th scope="col">Year</th>
              {columns.map((column) => (
                <th key={column.key} scope="col" className={column.isTotal ? 'is-total' : undefined}>
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.label}>
                <th scope="row">{row.label}</th>
                {columns.map((column) => (
                  <td key={column.key} className={column.isTotal ? 'is-total' : undefined}>
                    {renderValue(row.values[column.key], row.format)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="cac-evolution__note">
        Sales costs include all salaries and employer costs for the full commercial team, including the CRO and outsourced team.
      </p>
    </section>
  );
}
